import { Button, MessageBar, MessageBarActions, MessageBarBody } from "@fluentui/react-components";
import * as React from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";

export const UpdateBanner: React.FC = () => {
  const { updateAvailable, applyUpdate } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <MessageBar intent="warning" layout="singleline">
      <MessageBarBody>A new version is available.</MessageBarBody>
      <MessageBarActions>
        <Button appearance="transparent" size="small" onClick={applyUpdate}>
          Update now
        </Button>
      </MessageBarActions>
    </MessageBar>
  );
};
